import { IRequestDashboardData, IResponseDashboardData } from '@interfaces/api/IDashboard'
import { useQuery } from 'react-query'
import api from '@config/api'
import { useQueryConfig } from '@api/useQueryConfig'
// import { useQueryConfig } from '@api/useQueryConfig'

const Dashboard = {
  useGetDashBoardData: (params: IRequestDashboardData) =>
    useQuery(
      'getDashboardData' + params,
      () => api.post('/dashboard', params).then((res) => res.data.body as IResponseDashboardData),
      useQueryConfig
    ),
}

export default Dashboard
